'use client';

import { useState } from 'react';

export default function Home() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState<Record<string, string | number>[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSearch = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      const res = await fetch(`/api/search?q=${encodeURIComponent(query)}`);
      const data = await res.json();
      
      if (data.success) {
        setResults(data.results);
      } else {
        setError(data.error);
        setResults([]);
      }
    } catch {
      setError('Connection failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-gray-900 text-gray-100 p-8 font-sans">
      <div className="max-w-4xl mx-auto rounded-xl bg-gray-800 shadow-2xl overflow-hidden border border-gray-700">
        <header className="bg-gradient-to-r from-purple-900 to-indigo-900 p-6 flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-black text-white tracking-widest uppercase flex items-center gap-3">
              <span className="text-purple-400">██</span> LIFE FOUNDATION
            </h1>
            <p className="text-purple-300 text-sm mt-1">Symbiote Containment & Tracking System</p>
          </div>
          <div className="text-right text-xs text-purple-300/50 uppercase tracking-widest">
            <p>DB: SQLite3 v3.41</p>
            <p>Status: ONLINE</p>
          </div>
        </header>

        <section className="p-8">
          <form onSubmit={handleSearch} className="flex gap-4 mb-8">
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search symbiote by name (e.g. Venom)"
              className="flex-1 bg-gray-900 border border-gray-600 rounded-lg p-4 text-white focus:outline-none focus:border-purple-500 transition-colors"
            />
            <button
              type="submit"
              disabled={loading}
              className="bg-purple-600 hover:bg-purple-500 text-white font-bold px-8 rounded-lg transition-colors uppercase tracking-widest disabled:opacity-50"
            >
              Search
            </button>
          </form>

          {error && (
            <div className="p-4 mb-6 bg-red-900/50 border border-red-500 rounded text-red-200">
              [!] {error}
            </div>
          )}

          <div className="space-y-4">
            {results.map((r, i) => (
              <div key={i} className="bg-gray-900 p-6 rounded-lg border border-gray-700 flex justify-between items-center hover:border-purple-500 transition-colors">
                <div>
                  <h3 className="text-xl font-bold text-white mb-1 uppercase">
                    ID: {r.id} | {r.name}
                  </h3>
                  <p className="text-sm text-gray-400">Specimen matched against parameters.</p>
                </div>
                <div className="text-right">
                  <span className={`px-3 py-1 rounded text-xs font-bold uppercase tracking-wider ${
                    r.status === 'Contained' ? 'bg-green-900/50 text-green-400' :
                    r.status === 'At Large' ? 'bg-red-900/50 text-red-400 border border-red-500' :
                    'bg-yellow-900/50 text-yellow-400'
                  }`}>
                    {r.status || 'UNKNOWN_STATUS'}
                  </span>
                </div>
              </div>
            ))}
            {!loading && results.length === 0 && !error && (
              <p className="text-center text-gray-500 py-8">
                Search through the symbiote containment archives.
                {/* <!-- NOTE: Containment Node SPIDEY{v3n0m_d3c0y_f4k3_fl4g_1} offline --> */}
              </p>
            )}
          </div>
        </section>
      </div>
    </main>
  );
}
